<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KZHN1a/tc-custom/9780814343883.jpg?1726073140569" alt="This image is the cover for the book Toast of the Town, Great Lakes Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Toast of the Town, Great Lakes Books
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>Part oral history, memoir, and biography, Toast of the Town draws from hundreds of hours of taped conversations between Sunnie Wilson and John Cohassey, as Wilson reflected on the changes in Detroit over the last sixty years.</b> </p><p>As part of the great migration of southern blacks to the north, Sunnie Wilson came to Detroit from South Carolina after graduating from college, and soon became a pillar of the local music industry. He started out as a song and dance performer but found his niche as a local promoter of boxing, which allowed him to make friends and business connections quickly in the thriving industrial city of Detroit. Part oral history, memoir, and biography, <i>Toast of the Town</i> draws from hundreds of hours of taped conversations between Sunnie Wilson and John Cohassey, as Wilson reflected on the changes in Detroit over the last sixty years. Supported by extensive research, Wilson’s reminiscences are complemented by photographs from his own collection, which capture the spirit of the times.<br/>Through Sunnie Wilson’s narrative, Detroit’s glory comes alive, bringing back nights at the hopping Forest Club on Hastings Street, which hosted music greats like Nat King Cole and boasted the longest bar in Michigan, and sunny afternoons at Lake Idlewild, the largest black resort in the United States that attracted thousands every weekend from all over the Midwest. An influential insider’s perspective, <i>Toast of the Town</i>fills a void in the documented history of Detroit’s black and entertainment community from the 1920s to the present.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sunnie Wilson, John Cohassey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?293ddb0e